import { format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval } from 'date-fns'
import { useIntl } from 'react-intl'

const weeksDays = {
	pt: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
	es: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
}

export function Mouth({ month, year, holidays }) {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'

	const date = new Date(year, month)

	const generateCalendar = currentDate => {
		const startDate = startOfWeek(startOfMonth(currentDate))
		const endDate = endOfWeek(endOfMonth(currentDate))
		return eachDayOfInterval({ start: startDate, end: endDate })
	}

	const days = generateCalendar(date)

	const isHoliday = day => {
		const formattedDay = format(day, 'M/d')
		return holidays?.some(holiday => holiday.date === formattedDay)
	}

	const formattedMonth = new Intl.DateTimeFormat(language, { month: 'long' }).format(date)

	return (
		<div className='tw-h-[348px] tw-w-80 tw-flex tw-flex-col tw-items-center  tw-bg-white tw-rounded-lg'>
			<h2 className='tw-text-center tw-text-xl tw-flex tw-gap-2 tw-mb-6'>
				<span className='tw-text-gray-500 tw-font-bold'>{format(date, 'MM')}</span>
				<span className='tw-text-gray-500 tw-font-bold'>/</span>
				<span className='tw-text-gray-800 tw-font-bold'>{formattedMonth}</span>
			</h2>
			<div className='tw-grid tw-grid-cols-7 tw-gap-2 tw-w-full tw-p-4'>
				{weeksDays[language].map((day, index) => (
					<div key={index} className='tw-text-center tw-font-medium tw-text-gray-500'>
						{day}
					</div>
				))}
				{days.map((day, index) => (
					<div
						key={index}
						className={`tw-flex tw-justify-center tw-items-center tw-w-8 tw-h-8 tw-text-center  ${
							day.getMonth() === date.getMonth() ? 'tw-text-black' : 'tw-text-gray-300'
						}`}
					>
						<span
							className={
								isHoliday(day) && day.getMonth() === date.getMonth() ? 'tw-bg-purple-500 tw-rounded-md tw-text-white tw-px-1' : ''
							}
						>
							{format(day, 'dd')}
						</span>
					</div>
				))}
			</div>
		</div>
	)
}
